module.exports = "uniform sampler2D tDiffuse;\r\n\r\nvarying vec2 f_uv;\r\n\r\nvoid main() {\r\n\tvec4 color = texture2D(tDiffuse, f_uv);\r\n\tcolor.rgb *= color.rgb * color.a;\r\n\tcolor.a = 1.0;// After first round, we dont care about alpha\r\n    gl_FragColor = color;\r\n}   "


//////////////////
// WEBPACK FOOTER
// ./src/shaders/post/glare_threshold.frag.glsl
// module id = 23
// module chunks = 0